module.exports = __webpack_public_path__ + "img/oran_9kl.fb47d2fc.jpg";